import NaptimeResource from './NaptimeResource';

class ProgramEnrollmentsV2 extends NaptimeResource {
  static RESOURCE_NAME = 'programEnrollments.v2';

  declare programId: string;
}

export default ProgramEnrollmentsV2;
